import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import { Heading } from 'rebass'
import { Link } from 'gatsby'
import typography from '../../utils/typography'
import { ImageNavLink } from '../../utils/style'
import OutboundLink from '../OutboundLink'
import IconClose from '../../vectors/IconClose'
import DisableBodyScroll from '../DisableBodyScroll'
import HeaderContractedContactSocialLinks from '../HeaderContractedContactSocialLinks'
import HeaderLogo from '../HeaderLogo'
import IconPhone from '../../vectors/IconPhone'
import CalltracksPhoneNumber from '../CalltracksPhoneNumber'

const FullHeightBackground = styled.div`
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: ${(props) => props.theme.colors.grey_menu};
  overflow: scroll;
`

const Wrapper = styled(Flex)`
  width: 100vw;
  z-index: 11;
  line-height: 1;
  background: white;
  a:hover {
    color: ${(props) => props.theme.colors.grey_light};
  }
`

/*************************
 STYLES: Section Link & Close
 **************************/
const PrimaryNavOutboundLink = styled(OutboundLink)`
  height: ${typography.rhythm(1.3)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: ${(props) => props.theme.colors.grey_light_op30};
  ${ImageNavLink}
`

const IconCloseClear = styled.a`
  cursor: pointer;
  position: absolute;
  top: ${rem(6)};
  right: ${rem(15)};
  width: ${rem(17)};
  svg {
    width: ${rem(14)};
  }
  path {
    transition: fill 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  &:hover path {
    fill: rgba(66, 76, 94, 1);
  }
`

/*************************
 STYLES: Title
 **************************/
const TitleBox = styled(Box)`
  position: relative;
  z-index: 1;
  text-transform: uppercase;
  background: ${(props) => props.theme.colors.grey};

  h4 {
    color: white;
  }
`

/*************************
 STYLES: Dealerships
 **************************/

const DealershipBox = styled(Flex)`
  position: relative;
  z-index: 1;
  min-height: 40vh;
  background: ${(props) => props.theme.colors.grey_menu};
  border-bottom: 1px #5e6677 solid;
`

const DealershipItem = styled(Box)`
  text-align: left;
  color: ${(props) => props.theme.colors.blue};
  font-weight: 600;
  a {
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    color: ${(props) => props.theme.colors.white};
    font-weight: 400;
    display: block;
    padding: ${typography.rhythm(0.5)} 0 ${typography.rhythm(1.5)} 0;
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
  }

  a.active {
    background: ${(props) => props.theme.colors.grey_light};
  }
`

const HiddenCalltracksPhoneNumber = styled(CalltracksPhoneNumber)`
  display: none;
`

class HeaderContractedDealershipsModal extends React.PureComponent {
  constructor() {
    super()
    this.state = { hidden: true }
    this._hide = this._hide.bind(this)
    this._show = this._show.bind(this)
    this._reverse = this._reverse.bind(this)
  }

  _hide() {
    this.setState({ hidden: true })
  }

  _show() {
    this.setState({ hidden: false })
  }

  _reverse() {
    this.state.hidden ? this._show() : this._hide()
  }

  render() {
    const dealerships = this.props.dealerships || []
    const modal = this.state.hidden ? null : (
      <FullHeightBackground>
        <Wrapper flexWrap="wrap">
          <Box width={[4 / 12]}>
            <HeaderLogo location="/" compact />
          </Box>
          <Box width={[8 / 12]}>
            <IconCloseClear
              href={'javascript:void(0)'}
              onClick={this._reverse}
              id="router-contracted-dealership-close"
            >
              <IconClose />
            </IconCloseClear>
          </Box>

          <TitleBox width={[1 / 1]} py={20} pl={'8%'} pr={'2%'}>
            <Heading as="h4" fontSize={2}>
              Citygate dealerships
            </Heading>
          </TitleBox>

          <DealershipBox
            wrap
            as="nav"
            width={[1 / 1]}
            pl={'8%'}
            pr={'2%'}
            pt={50}
            pb={20}
          >
            {dealerships.map((dealership) => (
              <DealershipItem
                width={[1 / 2]}
                pr={30}
                key={`dealership:${dealership.name}`}
              >
                {dealership.name}:
                <Link
                  key={`dealership:link:${dealership.link.number}`}
                  to={`/${dealership.link.number}`}
                  className="router__visible-link"
                  activeClassName="active"
                >
                  {dealership.link.txt}
                </Link>
              </DealershipItem>
            ))}
          </DealershipBox>
        </Wrapper>

        <HeaderContractedContactSocialLinks />
      </FullHeightBackground>
    )

    return (
      <div>
        <DisableBodyScroll disableScroll={!this.state.hidden} />
        <PrimaryNavOutboundLink
          href={this.props.phoneNumber && this.props.phoneNumber.link}
          eventCategory="PhoneNumber"
          id="router-contracted-dealership"
          aria-label="Contracted dealership"
        >
          {this.props.phoneNumber && (
            <HiddenCalltracksPhoneNumber
              phoneNumber={this.props.phoneNumber.phoneNumber}
              calltracksClass={this.props.phoneNumber.calltracksClass}
              spanOnly={true}
            />
          )}
          <IconPhone />
        </PrimaryNavOutboundLink>
        {modal}
      </div>
    )
  }
}

export default HeaderContractedDealershipsModal
